import React from 'react';
import I18n from 'utils/I18n';
import { NavigationStudentNormalSmall } from '@strava/icons';
import styles from './styles.scss';
import { I18nPrefix } from '../../../shared/constants';

const Footnote = () => (
  <div className={styles.container} data-testid="footer">
    <div className={`text-footnote ${styles.row}`}>
      <div className={styles.icon}>
        <NavigationStudentNormalSmall />
      </div>
      <p>{I18n.t(`${I18nPrefix}.summary.students.reverify_footnote`)}</p>
    </div>
  </div>
);

export default Footnote;
